import { formatDateTime } from "../utils/orderHelpers";
import { FieldTimeOutlined } from "@ant-design/icons";

const getStatusColor = (statusName) => {
  const colors = {
    Pending: {
      bg: "bg-amber-50",
      border: "border-amber-500",
      dot: "bg-amber-500",
      text: "text-amber-900",
      line: "bg-amber-200",
    },
    Confirmed: {
      bg: "bg-blue-50",
      border: "border-blue-500",
      dot: "bg-blue-500",
      text: "text-blue-900",
      line: "bg-blue-200",
    },
    Accept: {
      bg: "bg-blue-50",
      border: "border-blue-500",
      dot: "bg-blue-500",
      text: "text-blue-900",
      line: "bg-blue-200",
    },
    Dispatch: {
      bg: "bg-purple-50",
      border: "border-purple-500",
      dot: "bg-purple-500",
      text: "text-purple-900",
      line: "bg-purple-200",
    },
    Delivered: {
      bg: "bg-emerald-50",
      border: "border-emerald-500",
      dot: "bg-emerald-500",
      text: "text-emerald-900",
      line: "bg-emerald-200",
    },
    Cancel: {
      bg: "bg-rose-50",
      border: "border-rose-500",
      dot: "bg-rose-500",
      text: "text-rose-900",
      line: "bg-rose-200",
    },
  };
  return (
    colors[statusName] || {
      bg: "bg-slate-50",
      border: "border-slate-500",
      dot: "bg-slate-500",
      text: "text-slate-900",
      line: "bg-slate-200",
    }
  );
};

export default function OrderTimeline({ orderStatusLogs, orderStatuses }) {

  const sortedLogs = [...(orderStatusLogs || [])].sort(
    (a, b) => new Date(a.CreatedAt) - new Date(b.CreatedAt)
  );

  if (!sortedLogs || sortedLogs.length === 0) {
    return (
      <div className="border border-slate-200 rounded-xl p-6 bg-gradient-to-br from-slate-50 to-white">
        <h3 className="text-sm font-semibold mb-3 text-slate-700 uppercase tracking-wide">
          Order Timeline
        </h3>
        <p className="text-sm text-slate-400 text-center py-6">
          No status updates yet
        </p>
      </div>
    );
  }

  return (
    <div className="border border-slate-200 rounded-xl p-4 shadow-sm">
      <div className="flex items-center gap-2 mb-6 pb-3 border-b border-slate-200">
        <FieldTimeOutlined className="text-slate-600 text-base" />
        <h3 className="text-sm font-semibold text-slate-700 uppercase tracking-wide">
          Order Timeline
        </h3>
      </div>

      <div className="relative pl-1">
        {sortedLogs.map((log, index) => {
          const statusName = orderStatuses[log.Id] || "Unknown";
          const colors = getStatusColor(statusName);
          const isLast = index === sortedLogs.length - 1;

          return (
            <div key={index} className="relative flex gap-4 pb-7 last:pb-0">
              {/* Timeline Line */}
              {!isLast && (
                <div
                  className={`absolute left-[5px] top-[1px] w-[2px] h-[calc(100%-8px)] ${colors.line}`}
                />
              )}

              {/* Status Dot */}
              <div className="relative z-10 flex-shrink-0">
                <div
                  className={`w-3 h-3 rounded-full ${colors.dot} shadow-lg ring-4 ring-white`}
                />
              </div>

              {/* Status Content */}
              <div className="flex-1 -mt-0.5">
                <div className="flex items-baseline justify-between gap-3 mb-1">
                  <span className={`font-semibold text-base ${colors.text} tracking-tight`}>
                    {statusName}
                  </span>
                  {isLast && (
                    <span className="text-[10px] bg-slate-900 text-white px-2 py-0.5 rounded-full font-semibold uppercase tracking-wider">
                      Current
                    </span>
                  )}
                </div>
                <p className="text-xs text-slate-500 font-medium">
                  {formatDateTime(log.CreatedAt)}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}